<template>
  <div
    class="card card-body card-chart"
    :class="{'bg-light': selectResearchItemMode}"
  >
    <div v-if="selectResearchItemMode">
      <div class="d-flex justify-content-between">
        <h4>
          {{ $t('phrase.select_question') }}
        </h4>

        <div>
          <v-button
            text="word.back"
            style-type="link"
            size="sm"
            @click="selectResearchItemMode = false"
          />
        </div>
      </div>

      <table class="table">
        <tr
          v-for="researchItem in choiceItems"
          :key="researchItem.id"
        >
          <td>
            <span v-html="formattedItemText(researchItem.title)"/>
          </td>
          <td>
            <v-button
              text="word.select"
              size="sm"
              @click="selectedResearchItem = researchItem; selectResearchItemMode = false"
            />
          </td>
        </tr>
      </table>
    </div>
    <div v-else class="h-100">
      <div
        v-if="loading"
        class="d-flex justify-content-center align-items-center h-100"
      >
        <v-loader/>
      </div>
      <div v-else>
        <v-chart
          :chart-type="chartType"
          :title="formattedItemText(selectedResearchItem.title)"
          :extra-actions="extraActions"
          :data-sets="dataSets"
          :labels="frequencyLabels"
          :swap-colors="swapColors"
          :as-percentage-data-labels="true"
          @select-question="selectResearchItemMode = true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import Chart from '@/organisation/components/dashboard/Chart.vue';
import { COLORS_WITHOUT_WHITE } from '@/common/utils/constants';
import {
  formattedItemText,
  isChoice,
  isMultiChoice,
} from '@/common/services/items';
import { mapGetters } from 'vuex';
import Loader from '@/common/components/Loader.vue';
import { calculateFrequencies } from '@/organisation/services/researches';

export default {
  name: 'ChoiceChartWidget',
  methods: { formattedItemText },
  components: {
    'v-loader': Loader,
    'v-chart': Chart,
    'v-button': Button,
  },
  data() {
    return {
      selectResearchItemMode: false,
      selectedResearchItem: null,
    };
  },
  computed: {
    ...mapGetters('researches', [
      'loadingResearchItems',
      'loadingResearchReviewSessions',
      'loadingResearchStatistics',
      'researchItems',
      'data',
    ]),
    loading() {
      return (
        this.loadingResearchItems
        || this.loadingResearchReviewSessions
        || this.loadingResearchStatistics
      );
    },
    answersByResearchItem() {
      return this.data.answersByResearchItem;
    },
    choiceItems() {
      return this.researchItems.filter((researchItem) => isChoice(researchItem.item.render_type));
    },
    dataSets() {
      return [{
        data: this.frequencies.map((freq) => (freq[1].toFixed(1) || 0)),
        backgroundColor: Object.values(COLORS_WITHOUT_WHITE),
        hoverBackgroundColor: Object.values(COLORS_WITHOUT_WHITE),
      }];
    },
    chartType() {
      if (isMultiChoice(this.selectedResearchItem.item.render_type)) {
        return 'bar';
      }
      return 'doughnut';
    },
    swapColors() {
      return isMultiChoice(this.selectedResearchItem.item.render_type);
    },
    frequencyLabels() {
      return this.frequencies.map((freq) => (freq[0]));
    },
    frequencies() {
      if (this.selectedResearchItem) {
        return calculateFrequencies(
          this.answersByResearchItem[this.selectedResearchItem.id],
          this.selectedResearchItem,
        );
      }
      return [];
    },
    extraActions() {
      if (this.choiceItems.length <= 1) {
        return [];
      }
      return [
        {
          icon: 'mouse-pointer',
          text: this.$t('phrase.select_question'),
          name: 'select-question',
        },
      ];
    },
  },
  created() {
    if (this.choiceItems.length > 0 && !this.selectedResearchItem) {
      // eslint-disable-next-line prefer-destructuring
      this.selectedResearchItem = this.choiceItems[0];
    }
  },
};
</script>
